<template>
    <h1 class="shop-headline">
        <template v-if="icon === 'cart'">
            <span class="icon-item icon-item--ghost">
                <span class="icon icon--shop">

                </span>
            </span>
        </template>
        <template v-if="icon === 'star'">
            <span class="icon-item icon-item--ghost">
                <span class="icon icon--wishlist-empty">

                </span>
            </span>
        </template>
        <span v-html="headline"></span>
    </h1>
</template>

<script>
export default {
    name: "shop-headline",
    props: {
        headline: String,
        icon: String
    }
}
</script>
